// extracted by mini-css-extract-plugin
export default {"normalcn":"styles_normalcn__NE5pT","normalen":"styles_normalen__ya5lK"};